import { FC, useEffect } from "react";
import { Grid, Typography, Link } from "@mui/material";
import { useWatch, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

import { SwitchInput, CheckboxInput } from "@dzambalaorg/mui-inputs-core";

import { StyledFormGroup } from "./styled";

export const Native: FC = () => {
  const form = useFormContext<any>();
  const value = useWatch({ name: "module.native" });

  useEffect(() => {
    form.setValue("native.token", value);
  }, [value]);

  return (
    <Grid>
      <SwitchInput name="module.native" />
      <StyledFormGroup>
        <CheckboxInput name="native.token" disabled />
        <Typography>
          <FormattedMessage id="pages.calculator.native.contract" />
          <Link href="https://dzambalaorg.github.io/admin/hierarchy/NATIVE/token/">more</Link>
        </Typography>
      </StyledFormGroup>
    </Grid>
  );
};
